var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceicon0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 109,
    viewBox: "0 0 121 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2y1x4gvoja",
    x1: "117.895%",
    x2: "23.788%",
    y1: "1.44%",
    y2: "72.966%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E89BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#2y1x4gvoja)",
    d: "M120.26 64L74.875 108.66 0 42.959 41.875 0z",
    opacity: 0.3,
    transform: "translate(-210 -1222) translate(210 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF3F9",
    d: "M41.875 1H118.875V63H41.875z",
    transform: "translate(-210 -1222) translate(210 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E89BF",
    fillRule: "nonzero",
    d: "M119.26 0h-77.6c-.394 0-.725.299-.778.681l-.007.106v62.426c0 .396.298.727.68.78l.105.007h77.6c.395 0 .726-.299.778-.681l.007-.106V.787c0-.396-.298-.727-.68-.78L119.26 0zm-.785 17.505v44.92h-76.03v-44.92h76.03zM84.142 27.892c-.434-.118-.813.044-.964.404l-.036.104-6.85 21.292-.023.108c-.055.346.075.647.377.82l.107.052.12.042c.014.007.042.01.16.01.293 0 .564-.167.7-.444l.045-.11 6.848-21.282c.13-.475-.075-.884-.484-.996zm-14.453 3.042c-.29-.29-.691-.316-1.001-.079l-.09.08-7.76 7.77c-.159.159-.24.352-.24.548 0 .157.052.312.154.448l.086.1 7.76 7.77c.158.159.35.24.546.24.195 0 .387-.081.545-.24.29-.29.317-.694.08-1.005l-.08-.09-7.213-7.223 7.213-7.223c.32-.32.32-.776 0-1.096zm22.634 0c-.32-.32-.773-.32-1.092 0-.29.29-.317.694-.08 1.005l.08.09 7.213 7.224-7.213 7.223c-.32.32-.32.776 0 1.095.158.159.35.24.546.24.156 0 .31-.052.447-.154l.099-.086 7.76-7.77c.158-.16.24-.352.24-.548 0-.157-.053-.312-.155-.449l-.085-.099-7.76-7.77zm26.152-29.36V15.93h-76.03V1.574h76.03zm-72.327 6.65l-.106.004c-.396.04-.705.381-.705.783 0 .396.298.728.68.78l.105.008h45.176l.106-.005c.396-.04.706-.38.706-.783 0-.396-.299-.727-.68-.78l-.106-.007H46.148zm67.81-.583h-.557l-.106.004c-.36.037-.648.322-.698.676l-.007.108v.557l.004.106c.037.36.321.65.674.699l.107.008h.556l.106-.005c.36-.036.649-.321.698-.675l.008-.108v-.557l-.004-.106c-.037-.361-.322-.65-.674-.7l-.108-.007zm-7.437 0h-.556l-.106.004c-.36.037-.649.322-.698.676l-.008.108v.56l.004.108c.035.378.29.649.665.695l.117.007h.556l.106-.005c.36-.036.648-.321.698-.675l.007-.108v-.557l-.004-.106c-.037-.361-.321-.65-.674-.7l-.107-.007zm-8.148 0h-.556l-.106.004c-.36.037-.649.322-.698.676l-.008.108v.557l.004.106c.037.36.322.65.674.699l.108.008h.556l.106-.005c.36-.036.648-.321.698-.675l.007-.108v-.557l-.004-.106c-.037-.361-.321-.65-.674-.7l-.107-.007z",
    transform: "translate(-210 -1222) translate(210 1222)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceicon0);
export default __webpack_public_path__ + "static/media/serviceicon0.3fb1a406cbe57e2e60cdf80e652b4397.svg";
export { ForwardRef as ReactComponent };